export { default } from './money'
export type { Props as MoneyProps } from './money'
